import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ProjectListPageSF from '../pages/projectapp/ProjectListPageSF'
import ProjectCreatePageSF from '../pages/projectapp/ProjectCreatePageSF'
import ProjectUpdatePageSF from '../pages/projectapp/ProjectUpdatePageSF'
import AlertRuleListPageSF from '../pages/projectapp/AlertRuleListPageSF'
import AlertRuleCreatePageSF from '../pages/projectapp/AlertRuleCreatePageSF'
import AlertRuleUpdatePageSF from '../pages/projectapp/AlertRuleUpdatePageSF'
import ProjectUserListPageSF from '../pages/projectapp/ProjectUserListPageSF'
import TaskListPageSF from '../pages/projectapp/TaskListPageSF'
import TaskDetailPageSF from '../pages/projectapp/TaskDetailPageSF'

const ProjectRouteUI = ({context}) =>
  <Switch>
    <Route exact path='/projects'
      render={() =>
        <ProjectListPageSF context={context} />
      }
    />
    <Route exact path='/projects/create'
      render={() =>
        <ProjectCreatePageSF context={context} />
      }
    />
    <Route exact path='/projects/:projectId/update'
      render={() =>
        <ProjectUpdatePageSF context={context} />
      }
    />
    <Route exact path='/projects/:projectId/alerts'
      render={() =>
        <AlertRuleListPageSF context={context} />
      }
    />
    <Route exact path='/projects/:projectId/alerts/create'
      render={() =>
        <AlertRuleCreatePageSF context={context} />
      }
    />
    <Route exact path='/projects/:projectId/alerts/:ruleId/update'
      render={() =>
        <AlertRuleUpdatePageSF context={context} />
      }
    />
    <Route exact path='/projects/:projectId/tasks'
      render={() =>
        <TaskListPageSF context={context} />
      }
    />
    <Route exact path='/projects/:projectId/users'
      render={() =>
        <ProjectUserListPageSF context={context} />
      }
    />
    <Route exact path='/tasks/:taskNumber'
      render={() =>
        <TaskDetailPageSF context={context} />
      }
    />

  </Switch>

export default ProjectRouteUI
